import { render, staticRenderFns } from "./MeasurementFieldDetail.vue?vue&type=template&id=47bff536"
import script from "./MeasurementFieldDetail.vue?vue&type=script&lang=js"
export * from "./MeasurementFieldDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports